<template>
  <div class="addEditProduct">
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title class="main-color pb-0">
          {{ $t("Add Product") }}
          <p :class="locale == 'en' ? 'close-right' : 'close-left'">
            <v-btn icon @click="closeDialog(false)">
              <v-icon>close</v-icon>
            </v-btn>
          </p>
        </v-card-title>

        <v-form v-model="valid" ref="form">
          <v-card-text>
            <v-tabs v-model="tab">
              <v-tab>{{ $t("General Info") }}</v-tab>
              <v-tab>{{ $t("Details") }}</v-tab>
            </v-tabs>
            <v-divider></v-divider>

            <v-tabs-items v-model="tab" class="mt-4">
              <v-tab-item>
                <v-card flat>
                  <div class="feature-image">
                    <label for="addFeetureImage" class="main-color"
                      >{{ $t("Product Main Picture") }} *</label
                    >
                    <img
                      height="30px"
                      style="margin:0 5px"
                      :src="product.main_image"
                      alt=""
                      v-if="product.main_image"
                    />
                    <v-file-input
                      style="display:none"
                      id="singleImage"
                      @change="addMainImage"
                      accept="image/*"
                    ></v-file-input>
                    <v-btn
                      icon
                      @click="openSingleImgDialog"
                      style="margin-bottom: 13px;"
                      ><v-icon color="grey" large>add</v-icon></v-btn
                    >
                  </div>
                  <p
                    class="error--text image-error"
                    v-if="mainImageSubmitted != ''"
                  >
                    {{ mainImageSubmitted }}
                  </p>

                  <div class="gallery-images">
                    <label for="AddOtherPictures" class="main-color">{{
                      $t("Other Picture(s)")
                    }}</label>
                    <div
                      class="image-div"
                      v-for="(image, index) in product.images"
                      :key="index"
                    >
                      <img
                        height="30px"
                        style="margin:0 5px"
                        :src="image.path"
                        alt=""
                        v-if="image.id"
                      />
                      <img
                        height="30px"
                        style="margin:0 5px"
                        :src="image"
                        alt=""
                        v-else
                      />
                      <v-btn icon @click="removeImage(index)">
                        <strong>
                          <v-icon color="red">close</v-icon>
                        </strong>
                      </v-btn>
                    </div>
                    <v-btn
                      icon
                      @click="openOtherImgDialog"
                      style="margin-bottom: 13px;"
                      ><v-icon color="grey" large>add</v-icon></v-btn
                    >
                    <v-file-input
                      multiple
                      style="display:none"
                      id="otherImages"
                      @change="addOtherImages"
                      accept="image/*"
                    ></v-file-input>
                  </div>

                  <v-row>
                    <v-col cols="12" sm="6" class="py-0 ">
                      <label for="product-name" class="main-color"
                        >{{ $t("Product Name") }} *</label
                      >
                      <v-text-field
                        :rules="[
                          validationRules.required,
                          validationRules.spaces
                        ]"
                        solo
                        dense
                        v-model="product.en.name"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="py-0 ">
                      <label for="product-name" class="main-color"
                        >{{ $t("Product Name in Arabic") }} *</label
                      >
                      <v-text-field
                        :rules="[
                          validationRules.required,
                          validationRules.spaces
                        ]"
                        solo
                        dense
                        v-model="product.ar.name"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="py-0 ">
                      <label for="product-name" class="main-color"
                        >{{ $t("Category") }} *</label
                      >
                      <v-select
                        :rules="[
                          validationRules.required,
                          validationRules.spaces
                        ]"
                        v-model="product.category_id"
                        solo
                        dense
                        :items="categories"
                        item-value="id"
                        item-text="name"
                      >
                      </v-select>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="6" class="py-0 ">
                      <label for="product-name" class="main-color">{{
                        $t("Curriculum")
                      }}</label>
                      <v-select
                        solo
                        dense
                        :items="curriculums"
                        item-value="id"
                        item-text="name"
                        @change="getGradesUnderCurriculum"
                        v-model="selectedCurriculum"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" class="py-0">
                      <label for="product-name" class="main-color">{{
                        $t("Grade")
                      }}</label>
                      <v-select
                        :items="grades"
                        item-value="id"
                        item-text="name"
                        solo
                        dense
                        v-model="product.grade_id"
                      >
                      </v-select>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="py-0">
                      <label for="product-name" class="main-color"
                        >{{ $t("Description") }}*</label
                      >
                      <v-textarea
                        solo
                        v-model="product.en.description"
                        :rules="[
                          validationRules.required,
                          validationRules.spaces
                        ]"
                      >
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0">
                      <label for="product-name" class="main-color"
                        >{{ $t("Description in Arabic") }}*</label
                      >
                      <v-textarea
                        solo
                        v-model="product.ar.description"
                        :rules="[
                          validationRules.required,
                          validationRules.spaces
                        ]"
                      >
                      </v-textarea>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-row>
                    <v-col cols="12" sm="6" class="py-0 pb-sm-3">
                      <label for="product-name" class="main-color">
                        {{ $t("Price") }} *
                      </label>
                      <v-text-field
                        :rules="[
                          validationRules.required,
                          validationRules.numeric,
                          validationRules.spaces
                        ]"
                        solo
                        dense
                        v-model="product.price"
                      >
                      </v-text-field>
                     
                    </v-col>
                    <v-col cols="12" sm="6" class="py-0 pb-sm-3">
                      <label for="product-name" class="main-color">
                        {{ $t("Price after Discount") }}
                      </label>
                      <v-text-field
                        solo
                        dense
                        v-model="product.discount_price"
                        :rules="[
                          saleLessThanPrice(
                            product.price,
                            product.discount_price
                          ),
                          validationRules.numeric
                        ]"
                      >
                      </v-text-field>
                    </v-col>
                     <div class="third-color note-style">
                      <span v-if="oc > 0"> + {{ oc }} {{ $t("currency") }} {{ $t("operation cost") }} </span>
                      <span> + {{ taxP }} % {{ $t("tax") }}  </span>
                       </div>
                  </v-row>
                  <v-row v-show="product.sizes_quantities.length == 0">
                    <v-col>
                      <label for="product-name" class="main-color">
                        {{ $t("Available Quantity") }} *
                      </label>
                      <v-text-field
                        :rules="[
                          requiredIfEmpty(
                            product.stock,
                            product.sizes_quantities
                          )
                        ]"
                        solo
                        dense
                        v-model="product.stock"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <label for="sizes" class="main-color">{{
                        $t("Available Size(s)")
                      }}</label>
                      <!-- internalLazyValue:Array -->
                      <v-chip-group
                        v-model="chipsArray"
                        ref="chips"
                        active-class="primary--text"
                        column
                        multiple
                        class="text-center sizes-chips"
                      >
                        <v-chip
                          v-for="size in sizes"
                          :key="size"
                          @click="addSize(size)"
                        >
                          {{ size }}
                        </v-chip>
                      </v-chip-group>
                    </v-col>
                  </v-row>

                  <v-row
                    v-for="(item, index) in product.sizes_quantities"
                    :key="index"
                  >
                    <v-col cols="2" sm="2">
                      <v-chip color="#ffc382" class="white--text mt-8">
                        {{ item.value }}
                      </v-chip></v-col
                    >
                    <v-col cols="10" sm="10">
                      <label for="item-quantity" class="main-color">{{
                        $t("Available Quantity")
                      }}</label>
                      <v-text-field
                        :rules="[
                          validationRules.required,
                          validationRules.numeric,
                          validationRules.spaces
                        ]"
                        v-model="item.quantity"
                        solo
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="tagsRow">
                    <v-col>
                      <label for="product-name" class="main-color">{{
                        $t("Tag(s)")
                      }}</label>

                      <vue-tags-input
                        v-model="tag"
                        :tags="product.tags"
                        :autocomplete-items="filteredItems"
                        @tags-changed="newTags => (product.tags = newTags)"
                        placeholder=""
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>

          <v-card-actions>
            <v-row>
              <v-col
                :class="locale == 'en' ? 'text-left' : 'text-right'"
                v-if="tab > 0"
              >
                <v-btn class="previous-btn" text @click="previous()">
                  {{ $t("Previous") }}
                </v-btn>
              </v-col>
              <v-col
                :class="locale == 'en' ? 'text-right' : 'text-left'"
                v-if="tab == 0"
              >
                <v-btn class="primary-btn" text @click="next()">
                  {{ $t("Next") }}
                </v-btn>
              </v-col>
              <v-col
                :class="locale == 'en' ? 'text-right' : 'text-left'"
                v-if="tab == 1"
              >
                <v-btn
                  class="primary-btn"
                  :loading="loading"
                  :disabled="loading"
                  @click.prevent="edit ? updateProduct() : addProduct()"
                >
                  {{ edit ? $t("Update") : $t("Add") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <Snack ref="snack"></Snack>
  </div>
</template>

<script>
import { validationMixin } from "../mixins/validationMixin";
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  name: "addEditProductComponent",
  mixins: [validationMixin],
  props: ["dialog", "productEditData", "edit" , "oc" , "taxP"],
  components: {
    VueTagsInput
  },
  data() {
    return {
      chipsArray: [],
      loading: false,
      tab: null,
      valid: false,
      sizes: [],

      product: {
        ar: {
          name: "",

          description: ""
        },
        en: {
          name: "",

          description: ""
        },
        category_id: "",
        grade_id: "",
        price: "",
        stock: null,
        discount_price: "",
        sizes_quantities: [],
        images: [],
        main_image: null,
        tags: []
      },
      mainImageSubmitted: "",
      curriculums: [],
      categories: [],
      grades: [],
      selectedCurriculum: "",
      tag: "",
      tags: [],
      autocompleteItems: [
        {
          id: 1,
          text: "Spain"
        },
        {
          id: 2,
          text: "France"
        },
        {
          id: 3,
          text: "USA"
        },
        {
          id: 4,
          text: "Germany"
        },
        {
          id: 5,
          text: "China"
        }
      ]
    };
  },

  watch: {
    edit: {
      handler() {
        if (this.edit == true) {
          this.product = this.productEditData;
          this.selectedCurriculum = this.productEditData.curriculum_id;
          this.getGradesUnderCurriculum();
        }
      }
    },
    tab: {
      handler() {
        if (this.tab == 1 && this.edit) {
          this.chipsArray = this.productEditData.sizes_for_chips;
        }
      }
    }
  },

  computed: {
    filteredItems() {
      return this.autocompleteItems.filter(i => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
      });
    }
  },
  methods: {
    previous() {
      this.tab = 0;
    },
    next() {
      this.tab = 1;
    },
    addSize(size) {
      /* eslint-disable */
      // @ts-ignoreconst
      let exist = false;
      let index = null;
      /* eslint-enable */
      if (this.product.sizes_quantities.length > 0) {
        this.product.sizes_quantities.forEach((item, i) => {
          if (item.value == size) {
            exist = true;
            index = i;
          }
        });
      }

      if (exist) {
        this.product.sizes_quantities.splice(index, 1);
      } else {
        const DefaultSizeObject = {
          value: "",
          quantity: ""
        };

        DefaultSizeObject.value = size;

        this.product.sizes_quantities.push(DefaultSizeObject);
      }
    },
    addProduct() {
      if (this.valid == false || this.product.main_image == null) {
        this.tab = 0;
        this.validate();

        if (this.product.main_image == null) {
          this.mainImageSubmitted = this.$i18n.t("required");
        }
      } else {
        this.loading = true;
        if (!this.product.stock || this.product.stock == "") {
          this.product.stock = null;
        }

        this.$http
          .post(this.getApiUrl + "/seller/product/create", this.product, {
            headers: {
              locale: localStorage.locale,
              Authorization: "Bearer " + localStorage.seller_token
            }
          })
          .then(Response => {
            if (Response.data.status.error) {
              this.$refs.snack.sendErrorAlert(Response.data.status.message);
            } else {
              this.closeDialog(true);
              this.$refs.snack.sendSuccessAlert(Response.data.status.message);
              this.getTagsAndSizes(true);
            }
            this.loading = false;
          });
      }
    },
    openSingleImgDialog() {
      document.getElementById("singleImage").click();
    },
    addMainImage(File) {
      const reader = new FileReader();
      reader.onload = e => {
        this.product.main_image = e.target.result;
      };
      reader.readAsDataURL(File);
      this.mainImageSubmitted = "";
    },
    openOtherImgDialog() {
      document.getElementById("otherImages").click();
    },
    addOtherImages(Files) {
      if (Files.length > 0) {
        Files.forEach(File => {
          /* eslint-disable */
          // @ts-ignore
          var reader = new FileReader();
          reader.onload = e => {
            this.product.images.push(e.target.result);
          };
          reader.readAsDataURL(File);
        });
      }
    },
    removeImage(index) {
      if (confirm(this.$i18n.t("delete_img_confirm_message"))) {
        if (this.product.images[index].id) {
          this.$http
            .get(
              this.getApiUrl +
                "/seller/image/remove/" +
                this.product.images[index].id,
              {
                headers: {
                  locale: localStorage.locale,
                  Authorization: "Bearer " + localStorage.seller_token
                }
              }
            )
            .then(response => {});
        }
        this.product.images.splice(index, 1);
      }
    },
    getCurriculums() {
      this.$http.get(this.getApiUrl + "/getCurriculums").then(response => {
        if (response.data.status.error == false) {
          this.curriculums = response.data.data;

          let defaultObj = {
            id: null,
            name: this.$i18n.t("None"),
            description: ""
          };

          // this.defaultObj.name = ;

          this.curriculums.unshift(defaultObj);
        }
      });
    },
    getCategories() {
      this.$http.get(this.getApiUrl + "/market/categories").then(response => {
        if (response.data.status.error == false) {
          this.categories = response.data.data;
        }
      });
    },
    getGradesUnderCurriculum() {
      this.grades = [];
      if (!this.edit) {
        this.product.grade_id = "";
      }

      if (this.selectedCurriculum !== null) {
        this.$http
          .get(
            this.getApiUrl +
              "/getGradesUnderCurriculum/" +
              this.selectedCurriculum
          )
          .then(response => {
            this.grades = response.data.data;

            let defaultObj = {
              id: null,
              name: this.$i18n.t("None")
            };

            this.grades.unshift(defaultObj);
          });
      }
    },
    getTagsAndSizes(tagOnly = false) {
      this.$http
        .get(this.getApiUrl + "/seller/tags", {
          headers: {
            locale: localStorage.locale,
            Authorization: "Bearer " + localStorage.seller_token
          }
        })
        .then(Response => {
          if (Response.data.status.error == false) {
            this.autocompleteItems = Response.data.data.tags;
            if (tagOnly == false) {
              this.sizes = Response.data.data.sizes;
            }
          }
        });
    },
    closeDialog(refresh) {
      this.chipsArray = [];
      this.resetValidation();
      this.product = {
        ar: {
          name: "",
          description: "",

        },
        en: {
          name: "",
          description: "",

        },
        category_id: "",
        grade_id: "",
        price: "",
        stock: null,
        discount_price: "",
        sizes_quantities: [],
        images: [],
        main_image: null,
        tags: []
      };
      this.tab = 0;
      this.$emit("dialogClosed", refresh);
    },

    updateProduct() {
      this.loading = true;
      this.$http
        .post(
          this.getApiUrl + "/seller/product/update/" + this.product.id,
          this.product,
          {
            headers: {
              locale: localStorage.locale,
              Authorization: "Bearer " + localStorage.seller_token
            }
          }
        )
        .then(Response => {
            this.loading = false;
          if (Response.data.status.error) {
            this.$refs.snack.sendErrorAlert(Response.data.status.message);
          } else {
            this.closeDialog(true);
            this.$refs.snack.sendSuccessAlert(Response.data.status.message);
            this.getTagsAndSizes(true);
          }
        });
    }
  },
  mounted() {
    this.getCategories();
    this.getCurriculums();
    this.getTagsAndSizes();
    console.log(this.oc) ;
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/_variables.scss";

.col,
.col-sm-2,
.col-2,
.col-sm-10,
.col-10 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.v-tabs {
  .v-tabs-slider-wrapper {
    color: $main-color !important;
  }
  .v-tab--active {
    color: $main-color;
    font-weight: bold;
  }
}
.v-card__actions {
  .primary-btn {
    padding: 0 30px !important;
    width: auto !important;
    border-radius: 5px;
  }
}

.v-chip-group .v-chip--active {
  background-color: #ffc382;
  color: #ffffff !important;
}

.v-btn {
  // align-items: start !important;
}

.v-card__text {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.close-right {
  position: absolute;
  right: 0;
}
.close-left {
  position: absolute;
  left: 0;
}
strong {
  font-weight: bold !important;
}

.v-tab {
  font-size: 1rem;
}

.tagsRow {
  margin-bottom: 25px;
}

.image-div {
  position: relative;
  display: inline-block;
  .v-btn {
    position: absolute;
    top: 0;
    right: 0;
    display: none !important;
  }
}

.image-div:hover .v-btn {
  display: inline-block !important;
}
.image-div .v-btn:hover {
  display: inline-block !important;
}
.note-style{
    padding: 0px 14px;
    margin-top: -1rem;
    margin-bottom: 1rem;
}
</style>
